import { render, staticRenderFns } from "./NewsCreateAdmin.vue?vue&type=template&id=5715194f"
import script from "./NewsCreateAdmin.vue?vue&type=script&lang=js"
export * from "./NewsCreateAdmin.vue?vue&type=script&lang=js"
import style0 from "./NewsCreateAdmin.vue?vue&type=style&index=0&id=5715194f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports